/**
 * La couleur d'une bulle, la teinte de son projet (chantier nettoyage-regles, ticket 03) : une
 * valeur CSS qui renvoie à un jeton de `partage/styles/jetons.css` (`--dossier-1` à `--dossier-5`),
 * jamais une couleur en dur. Deux replis, selon l'écran, quand la bulle n'a pas de couleur :
 * le seul endroit du client qui écrit `var(--<couleur>)`.
 */

/**
 * La teinte, ou l'accent sans couleur : la fiche, la feuille, « Déplacer », la barre d'ajout, la
 * Carte, et partout où la couleur est toujours là (le choix des couleurs, les dessins des gestes,
 * un maillon de la boucle).
 */
export function teinteOuAccent(couleur: string | null | undefined): string {
  return couleur ? `var(--${couleur})` : 'var(--accent)';
}

/**
 * La teinte, ou la première couleur des projets sans couleur : les lignes qui disent leur projet
 * (Maintenant, la Journée, l'Agenda, Projets, le +).
 */
export function teinteDuProjet(couleur: string | null | undefined): string {
  return `var(--${couleur ?? 'dossier-1'})`;
}
